import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IDocumentUploadResponse } from '@core-lib/models';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { AuthSharedService } from './auth.service';

@Injectable({
	providedIn: 'root'
})
export class CommonAlfrescoService {
	get tenantKey() {
		return this.authService.currentTenantKey;
	}

	constructor(
		private http: HttpClient,
		private authService: AuthSharedService
	) {}

	getImportEnMasseModelByType(type: string): Observable<any> {
		return this.http.get<Blob>(`${environment.apiUrl}/ressources/import-en-masse/${type}/content`, {
			responseType: 'blob' as 'json',
			observe: 'response'
		});
	}

	uploadCBFile(form: any): Observable<IDocumentUploadResponse> {
		const formData = new FormData();
		if (form.coordonneBancaireId) {
			for (let i = 0; i < form?.documents?.length; i++) {
				formData.append('documents[' + i + '][files]', form.documents[i]?.file);
				formData.append('documents[' + i + '][libelle]', form.documents[i]?.libelle);
				formData.append('documents[' + i + '][commentaire]', form.documents[i]?.commentaire);
				formData.append('documents[' + i + '][typePieceJointeId]', form.documents[i]?.typePieceJointeId);
			}
			return this.http.post<any>(
				`${environment.apiUrl}/t/${this.tenantKey}/document/coordonnees-bancaires/${form.coordonneBancaireId}/compte/upload/list`,
				formData
			);
		}
	}
}
